import { render, staticRenderFns } from "./CmgPasswordResetRequestComplete.vue?vue&type=template&id=c76c308c&scoped=true&lang=pug&"
import script from "./cmg-password-reset-request-complete.ts?vue&type=script&lang=ts&"
export * from "./cmg-password-reset-request-complete.ts?vue&type=script&lang=ts&"
import style0 from "./CmgPasswordResetRequestComplete.vue?vue&type=style&index=0&id=c76c308c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76c308c",
  null
  
)

export default component.exports